export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Gradient Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/980e9c2619bc3eb1b40143c2d872c648.jpg"
          alt="Aesthetic Clinic"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-esthe-pale-taupe/40 via-esthe-light-bronze/30 to-esthe-mocha/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-8 py-32 text-center w-full">
        <p className="text-esthe-floral-white text-sm tracking-widest uppercase mb-6 font-medium">
          / PREMIUM AESTHETIC TREATMENTS
        </p>
        <h1 className="text-7xl md:text-8xl font-serif mb-8 leading-tight text-white">
          Elevate Your
          <br />
          Natural Beauty
        </h1>
        <p className="text-xl text-esthe-floral-white/90 mb-12 max-w-2xl mx-auto leading-relaxed">
          Experience transformative aesthetic treatments tailored to enhance your unique features with precision and artistry
        </p>
        <div className="flex flex-wrap gap-6 justify-center">
          <a
            href="#services"
            className="px-10 py-4 bg-gradient-to-r from-esthe-light-bronze to-esthe-mocha text-esthe-floral-white rounded-full text-base font-medium hover:from-esthe-mocha hover:to-esthe-light-bronze transition-all shadow-lg whitespace-nowrap cursor-pointer"
          >
            Explore Treatments
          </a>
          <a
            href="#contact"
            className="px-10 py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 rounded-full text-base font-medium hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
          >
            Book Consultation
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/70 rounded-full"></div>
        </div>
      </div>
    </section>
  );
}
